module.exports = __webpack_public_path__ + "static/media/2020-03-21_1584799703310.fbb0351a.png";